import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../common/selectCurrencyUnit/slice'
import peerAnalysisService from '../../../store/peerAnalysisService'

export const getFinancialAnalysis = createAsyncThunk(
  'companyAnalysis/peerAnalysis/getFinancialAnalysis',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await peerAnalysisService.getFinancialAnalysis(params)
      if (response.success) {
        dispatch(
          calculateDefaultUnit({
            screen: SCREEN.PEER_ANALYSIS,
            getValues: () => {
              const result = []
              response.data.forEach(({ ratioItems = [] }) => {
                ratioItems
                  .filter((i) => i.unit === 'VND')
                  .forEach(({ companyItems = [] }) => {
                    companyItems.forEach(({ values = [] }) => {
                      values.forEach((item) => {
                        result.push({ value: item.value, year: item.realYear })
                      })
                    })
                  })
              })
              return result
            },
          }),
        )
        return response.data
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
